import { Injectable } from '@angular/core';
import { AppConfig } from 'src/app/app-config';
import { Observable } from 'rxjs';
import { IFilterContentParams } from '../../../../core/models/i-filter-content';
import { IContentResults } from '../../../../core/models/i-content';
import { RestService } from 'src/app/shared/services/rest-service';

@Injectable({
  providedIn: 'root',
})
export class ContentService {
  static readonly ENTITY_IDENTIFIER: string = 'content';
  private readonly BASE_CONTENT_ROUTE = `api/${ContentService.ENTITY_IDENTIFIER}`;
  contentResultLimit: number;
  private readonly BUILD_HTTP_ROUTE = (...args) =>
    this.restService.BUILD_HTTP_ROUTE(this.BASE_CONTENT_ROUTE, ...args);

  constructor(
    private restService: RestService,
    private appConfig: AppConfig,
  ) {
    this.contentResultLimit = this.appConfig.contentResultLimit;
  }

  getFiltered$(
    deliveryTargetCodeFilter: string[],
    contentListCode: string,
    filterParams: IFilterContentParams,
  ): Observable<IContentResults> {
    const params = this.restService.buildParamsObjectWithPaging(
      {
        includeContentListInfoFor: contentListCode,
        headline: filterParams.headline ?? '',
        authors: filterParams.authors ?? '',
        publishedDateFrom: filterParams.publishDateFrom
          ? new Date(filterParams.publishDateFrom).toDateString()
          : '',
        publishedDateTo: filterParams.publishDateTo
          ? new Date(filterParams.publishDateTo).toDateString()
          : '',
        deliveryTargetCodes: deliveryTargetCodeFilter.join(','),
        contentListId: filterParams.contentListId ?? '',
      },
      filterParams.pageNumber,
      filterParams.pageSize,
    );

    return this.restService.get$<IContentResults>(this.BUILD_HTTP_ROUTE(), {
      params,
    });
  }
}
